import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  CreditCard,
  Banknote,
  Wallet,
  BarChart,
  Bell,
  Settings,
  MessageSquare,
  LogOut,
  Mail,
  ShieldCheck,
} from "lucide-react";

const navItems = [
  { name: "Dashboard", path: "/admin", icon: <LayoutDashboard /> },
  { name: "Users", path: "/admin/users", icon: <Users /> },
  { name: "KYC Reviews", path: "/admin/kyc", icon: <ShieldCheck /> },
  { name: "Transactions", path: "/admin/transactions", icon: <CreditCard /> },
  { name: "Loans", path: "/admin/loans", icon: <Banknote /> },
  { name: "Wallets", path: "/admin/wallets", icon: <Wallet /> },
  { name: "Commissions", path: "/admin/commissions", icon: <Banknote /> },
  { name: "Emails", path: "/admin/send-emails", icon: <Mail /> },
  { name: "Stats", path: "/admin/stats", icon: <BarChart /> },
  { name: "Notifications", path: "/admin/notifications", icon: <Bell /> },
  { name: "Reviews", path: "/admin/reviews", icon: <MessageSquare /> },
  { name: "Settings", path: "/admin/settings", icon: <Settings /> },
  { name: "Support", path: "/admin/support", icon: <MessageSquare /> },
  { name: "Logout", path: "/logout", icon: <LogOut /> },
];

export default function Sidebar({ open, setOpen }) {
  return (
    <>
      {/* Sidebar toggle button (X icon) visible only on mobile */}
      {open && (
        <button
          className="md:hidden fixed top-4 right-4 z-50 bg-white text-blue-600 p-2 rounded-full shadow-lg"
          onClick={() => setOpen(false)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}

      <aside
        className={`
          fixed top-0 left-0 z-40 w-64 h-full bg-white dark:bg-gray-900 border-r shadow-lg transition-transform duration-300 ease-in-out
          ${open ? "translate-x-0" : "-translate-x-full"} md:translate-x-0
        `}
      >
        <div className="h-16 flex items-center px-6 border-b border-gray-200 dark:border-gray-700">
          <span className="text-lg font-bold text-blue-600">NGC Admin</span>
        </div>
        <nav className="flex flex-col space-y-1 p-4">
          {navItems.map((item) => (
            <NavLink
              to={item.path}
              key={item.name}
              className={({ isActive }) =>
                `flex items-center space-x-3 px-4 py-2 rounded-lg hover:bg-blue-50 dark:hover:bg-gray-800 text-sm font-medium transition-colors duration-150 ${
                  isActive
                    ? "bg-blue-100 text-blue-700 dark:bg-gray-700"
                    : "text-gray-700 dark:text-gray-300"
                }`
              }
              onClick={() => setOpen(false)}
            >
              {item.icon}
              <span>{item.name}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
}
